import { DesktopArchiveItem } from "@/features/archive/components/desktop/DesktopArchiveItem";
import type { ArchiveThread } from "@/features/archive/types";
import { DesktopCatalogGridLayout } from "@/features/catalog/components/desktop/DesktopCatalogGridLayout";
import { Message } from "@/shared/ui/feedback";

interface DesktopArchiveGridProps {
  threads: ArchiveThread[];
  columns: number;
  imageSize: number;
  emptyMessage?: string;
}

/**
 * 過去ログ一覧(PC版)。カタログのdesktop-catalog-gridをそのまま流用し、
 * カタログ設定と同じ列数・画像サイズで表示する。
 */
export const DesktopArchiveGrid: React.FunctionComponent<
  DesktopArchiveGridProps
> = ({
  threads,
  columns,
  imageSize,
  emptyMessage = "過去ログはまだありません",
}: DesktopArchiveGridProps) => {
  if (threads.length === 0) {
    return <Message variant="info">{emptyMessage}</Message>;
  }

  return (
    <DesktopCatalogGridLayout columns={columns} imageSize={imageSize}>
      {threads.map((thread) => (
        <DesktopArchiveItem key={thread.threadId} thread={thread} />
      ))}
    </DesktopCatalogGridLayout>
  );
};
